/**
 * Login com Google (03/10/2026) — a ida e a volta.
 *
 * Mesmo molde do Google Agenda: o front vai até o Google, volta com um `code`
 * e a API troca o code pelo token com o client secret. Aqui é página inteira,
 * não popup: no login não há tela por trás para preservar.
 *
 * O `state` é a defesa contra alguém fazer o navegador de outra pessoa voltar
 * com um code dele (e entrar na conta dele sem perceber). Ele nasce aqui, fica
 * no sessionStorage desta aba e é conferido na volta.
 */

const CHAVE_STATE = 'google-login-state';

/** Para onde o Google devolve. Precisa estar cadastrado no cliente OAuth do Google Cloud. */
export const redirectUriGoogle = () => `${window.location.origin}/login/google`;

/** Leva a aba para a escolha de conta do Google. Só volta se der erro. */
export async function irParaGoogle(): Promise<void> {
  const apiUrl = import.meta.env.VITE_API_URL;

  const bytes = crypto.getRandomValues(new Uint8Array(24));
  const state = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  sessionStorage.setItem(CHAVE_STATE, state);

  const params = new URLSearchParams({ redirectUri: redirectUriGoogle(), state });
  const resposta = await fetch(`${apiUrl}/api/Auth/Google/Url?${params}`, { credentials: 'include' });
  if (!resposta.ok) throw new Error('Falha ao montar a URL do Google');

  const { url } = await resposta.json();
  window.location.assign(url);
}

/** Confere e consome o state da volta. Usar uma vez só. */
export function conferirState(recebido: string | null): boolean {
  const esperado = sessionStorage.getItem(CHAVE_STATE);
  sessionStorage.removeItem(CHAVE_STATE);
  return !!recebido && !!esperado && recebido === esperado;
}

/** O que a volta do Google entrega quando a pessoa ainda não tem conta. */
export interface CadastroGoogle {
  idToken: string;
  nome: string | null;
  email: string;
}

/** Depois dos cookies emitidos: carrega o usuário como o login por senha faz. */
export async function carregarUsuarioLogado(): Promise<boolean> {
  const apiUrl = import.meta.env.VITE_API_URL;
  const me = await fetch(`${apiUrl}/api/Auth/Me`, { credentials: 'include' });
  if (!me.ok) return false;
  localStorage.setItem('user', JSON.stringify(await me.json()));
  return true;
}
